export default __webpack_public_path__ + "sprite.a46bd18cd8f1b85c21a0.svg";